//base list needs to be incremented by 1
//in order to know if there are more elements available we need to be looking ahead for one element in order to properly show load more button
//set this to a lower number for testing

const actualBaseList = 5
export const baseListCount =  actualBaseList + 1;
export const listIncrementCount = baseListCount - 1;
